import BookingForm from '@components/Home/BookingForm';
import CounterBar from '@components/Home/CounterBar';
import CustomerComments from '@components/Home/CustomerComments';
import DoctorList from '@components/Home/DoctorList';
import GalleryService from '@components/Home/GalleryService';
import HospitalCarousel from '@components/Home/HospitalCarousel';
import News from '@components/Home/News';
import Partners from '@components/Home/Partners';
import ServiceSection from '@components/Home/ServiceSection';
import BannerHomeSlide from '@components/Home/SlideHome';
import ThePressSaysAboutTnh from '@components/Home/ThePressSaysAboutTnh';
import WhyChoooseTnh from '@components/Home/WhyChoooseTnh';
import { useAuth } from '@contexts/AuthProvider';
import { useRouter } from 'next/router';
import { useRef } from 'react';
import {NextSeo} from 'next-seo';
import AppConfigService from '@services/app-config.service';
import ConfigService from '@services/config.service';
import {getAutoSEO} from '@helper/seo/seo';

export default function Home(props) {
    const {seoPage} = props;
    // const {bannerHomeSlide, bannerSaleTop, bannerLeft, bannerRight, bannerSaleHot, newsHome} = props;
    const { lang } = useAuth();
    const bannerScroll = useRef(null);
    const router = useRouter();
    let { query } = router;

    return (
        <>
            {seoPage && <NextSeo {...seoPage} />}
            <h1 className="sr-only">
                {router.locale === 'en'
                    ? 'TNH Hospital Group - Patient-centered healthcare'
                    : 'CTCP Tập đoàn Bệnh viện TNH - Chăm sóc sức khỏe lấy người bệnh làm trung tâm'}
            </h1>
            <BannerHomeSlide />
            <CounterBar />
            <WhyChoooseTnh />
            <DoctorList />
            <ServiceSection />
            <GalleryService />
            <CustomerComments />
            <BookingForm />
            <News />
            <Partners />
            <ThePressSaysAboutTnh />
            <HospitalCarousel />
        </>
    );
}

Home.PageName = 'HOME';

Home.getInitialProps = async (context) => {
    try {
        const ctx = context || {};
        const appConfigService = new AppConfigService(ctx);
        const seoConfig = await appConfigService.getAppConfig({page: 'SEO'});
        
        // Fetch stats để tạo SEO tự động
        let pageData = {};
        try {
            const configService = new ConfigService(ctx);
            const statsResponse = await configService.postAppConfig(
                'WEB_NUM_HOSPITAL_FACILITIES,WEB_NUM_HOSPITAL_BEDS,WEB_NUM_HOSPITAL_DOCTORS,WEB_NUM_HOSPITAL_PATIENTS_SERVED'
            );
            pageData.facilities = statsResponse?.WEB_NUM_HOSPITAL_FACILITIES || '0';
            pageData.beds = statsResponse?.WEB_NUM_HOSPITAL_BEDS || '0';
            pageData.doctors = statsResponse?.WEB_NUM_HOSPITAL_DOCTORS || '0';
            pageData.patients = statsResponse?.WEB_NUM_HOSPITAL_PATIENTS_SERVED || '0';
        } catch (err) {
            console.error('Failed to fetch stats for SEO:', err);
        }
        
        // Sử dụng getAutoSEO để tạo SEO tự động từ stats
        let seoPage = getAutoSEO('HOME', seoConfig, pageData);
        
        // Đảm bảo canonical URL trỏ về trang chủ
        const webUrl = process.env.NEXT_PUBLIC_WEB_URL || 'https://tnh.com.vn';
        seoPage.canonical = webUrl;
        if (seoPage.openGraph) {
            seoPage.openGraph.url = webUrl;
        }
        
        return {seoPage};
    } catch (error) {
        console.error('Failed to fetch SEO for home page:', error);
        // Fallback to default SEO sẽ được handle bởi DefaultSeo trong _app.js
        return {seoPage: null};
    }
};
